<div [ngClass]="{'tw-flex tw-flex-col tw-gap-4': true, 'xl:!tw-items-center xl:!tw-flex-row xl:!tw-justify-between': !distributeToAll}">
  <div class="tw-flex tw-flex-row">
    <div class="tw-flex tw-flex-row tw-items-center tw-gap-8">
      <label class="tw-text-gray-700 tw-font-bold tw-mb-0 tw-w-36" [hidden]="!showLabel">Distribution</label>

      <mat-slide-toggle [shown]="!readonly" class="tw-mr-1" id="allDisplaysToggle{{inputId}}" (change)="outputDistributeToAll()" [(ngModel)]="distributeToAll" aria-labelledby="distributeToAllLabel{{inputId}}">
        <span id="distributeToAllLabel{{inputId}}" class="tw-ml-2 tw-cursor-pointer tw-truncate" [shown]="!readonly || distributeToAll">Show on all displays{{ enableSubcompanyDistributeToAll ? ' in this company' : ''}}.</span>
      </mat-slide-toggle>
      @if (readonly && !distributeToAll) {
        <span id="distributeToAllLabel{{inputId}}">{{ distributionSelectionMessage }}</span>
      }
    </div>
  </div>
  <span id="distributionField{{inputId}}" class="tw-text-blue-600 tw-cursor-pointer hover:tw-text-blue-800 tw-underline tw-flex tw-items-end tw-w-1/2" timeline="timeline" (click)="manage()" [shown]="!readonly && !distributeToAll" tabindex="0" (keyup.enter)="manage()">{{ distributionSelectionMessage }}</span>
  @if (subcompanyDistributeToAllAvailable) {
    <div class="tw-flex tw-flex-row">
      <div class="tw-flex tw-flex-row tw-items-center">
        <mat-slide-toggle [shown]="!readonly" class="tw-mr-1" id="allSubcompanyDisplaysCheckbox{{inputId}}" (change)="outputSubcompanyDistributeToAll()" [(ngModel)]="subcompanyDistributeToAll" aria-labelledby="subcompanyDistributeToAllLabel{{inputId}}">
          <span id="subcompanyDistributeToAllLabel{{inputId}}" class="tw-ml-2 tw-cursor-pointer tw-truncate">Show on all displays in sub companies.</span>
        </mat-slide-toggle>
      </div>
    </div>
  }
</div>
